import { computed, Injectable, signal } from '@angular/core';
import { KeyboardService } from './keyboard.service';

// On the web the browser resizes the layout itself
// (interactive-widget=resizes-content in index.html), so this is inert.
@Injectable()
export class WebKeyboardService extends KeyboardService {
  readonly keyboardHeight = signal(0).asReadonly();
  readonly isKeyboardOpen = computed(() => false);

  init(): void {}
}
